import React from 'react';
import TextTranslate from '../../../Components/TextTranslate/TextTranslate';
import CarRow from './CarRow';

const Car = ({onChange, values, errors, ...props}) => {

    return (
        <>
        <hr/>
        <div className="car-tab row">
            <div className="col-12 form-group">
                <h3><TextTranslate name="travel-travelling-by" fallback="Travelling by" textOnly/> <strong><TextTranslate name="travel-car" fallback="Car" textOnly/></strong></h3>
                <p className="d-block"><TextTranslate name="travel-travelling-by-note" fallback="Please fill out the necessary information." textOnly/></p>
                <CarRow values={values} errors={errors} onChange={onChange} />
            </div>
        </div>
        </>
    )
}

export default Car;
